var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "mb-4", attrs: { outlined: "" } },
    [
      _c(
        "v-card-title",
        { staticClass: "text-subtitle-1 py-2" },
        [
          _c(
            "v-icon",
            { attrs: { left: "", small: "", color: "green darken-2" } },
            [_vm._v("mdi-flag-checkered")]
          ),
          _vm._v(" Planejamento de Oferta "),
          _c("v-spacer"),
          _vm.totalIntents > 0
            ? _c(
                "v-chip",
                {
                  staticClass: "ml-2",
                  attrs: { small: "", color: "green lighten-4" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.totalIntents) +
                      " disciplina(s) planejada(s) "
                  ),
                ]
              )
            : _vm._e(),
          _vm.draftMode && _vm.totalIntents > 0
            ? _c(
                "v-chip",
                {
                  staticClass: "ml-2",
                  attrs: { small: "", color: "amber lighten-4" },
                },
                [
                  _c("v-icon", { attrs: { "x-small": "", left: "" } }, [
                    _vm._v("mdi-content-save-edit-outline"),
                  ]),
                  _vm._v(" Rascunho — será salvo com a turma "),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-menu",
            {
              attrs: { "offset-y": "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "ml-2",
                              attrs: {
                                small: "",
                                text: "",
                                color: "purple darken-1",
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-cursor-default-click"),
                          ]),
                          _vm._v(" Adicionar disciplina "),
                          _c("v-icon", { attrs: { right: "", small: "" } }, [
                            _vm._v("mdi-chevron-down"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-list-item",
                    {
                      attrs: { disabled: !_vm.matrizDisciplines.length },
                      on: { click: _vm.openMatrizPicker },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        { staticClass: "mr-2" },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-layers-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v("Da matriz da turma"),
                          ]),
                          !_vm.matrizDisciplines.length
                            ? _c("v-list-item-subtitle", [
                                _vm._v(" Selecione uma matriz acima "),
                              ])
                            : _c("v-list-item-subtitle", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.matrizDisciplines.length) +
                                    " disciplina(s) disponíveis "
                                ),
                              ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      on: {
                        click: function ($event) {
                          _vm.findDisciplineDialog = true
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        { staticClass: "mr-2" },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-magnify"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [_vm._v("Buscar em todas")]),
                          _c("v-list-item-subtitle", [
                            _vm._v("Universo completo de disciplinas"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.groupId
            ? _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: {
                    icon: "",
                    small: "",
                    loading: _vm.loading,
                    title: "Atualizar",
                  },
                  on: { click: _vm.load },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("mdi-refresh"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "pa-3 grey lighten-5" },
        [
          _vm.showSelect
            ? _c("v-select", {
                attrs: {
                  value: _vm.localSequencyId,
                  items: _vm.modules || [],
                  "item-text": "name",
                  "item-value": "id",
                  label: "Módulo da Matriz",
                  disabled: !_vm.modules || !_vm.modules.length || _vm.adding,
                  loading: _vm.adding,
                  hint: _vm.moduleHint,
                  "persistent-hint": "",
                  dense: "",
                  outlined: "",
                  "hide-details": "auto",
                  clearable: "",
                },
                on: { change: _vm.onSequencyChange },
              })
            : _vm._e(),
          _vm.addMessage
            ? _c(
                "v-alert",
                {
                  staticClass: "mt-2 mb-0 caption",
                  attrs: { type: _vm.addMessageType, text: "", dense: "" },
                },
                [_vm._v(" " + _vm._s(_vm.addMessage) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        { staticClass: "py-2" },
        [
          _vm.loading && _vm.groups.length === 0
            ? _c(
                "div",
                { staticClass: "text-center grey--text py-4" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: "20", width: "2" },
                  }),
                  _c("span", { staticClass: "ml-2 caption" }, [
                    _vm._v("Carregando planejamento…"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.offerErrors.length
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-3",
                  attrs: { type: "error", text: "", dense: "" },
                },
                [
                  _c("div", { staticClass: "font-weight-medium" }, [
                    _vm._v(
                      "A turma não foi criada. Ajuste o planejamento e salve novamente."
                    ),
                  ]),
                  _c(
                    "ul",
                    { staticClass: "ma-0 mt-1 pl-4 caption" },
                    _vm._l(_vm.offerErrors, function (err, i) {
                      return _c("li", { key: i }, [_vm._v(_vm._s(err))])
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm.draftMode && !_vm.draftIntents.length
            ? _c(
                "div",
                { staticClass: "grey--text caption text-center py-3" },
                [
                  _vm._v(
                    " Monte o planejamento agora. As disciplinas serão gravadas junto com a turma. "
                  ),
                ]
              )
            : _vm.draftMode
            ? _c(
                "div",
                [
                  _c("v-simple-table", { attrs: { dense: "" } }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Disciplina")]),
                        _c("th", { attrs: { width: "100" } }, [
                          _vm._v("Código"),
                        ]),
                        _c(
                          "th",
                          { staticClass: "text-right", attrs: { width: "80" } },
                          [_vm._v("CH")]
                        ),
                        _c("th", { attrs: { width: "120" } }, [
                          _vm._v("Origem"),
                        ]),
                        _c(
                          "th",
                          { staticClass: "text-right", attrs: { width: "60" } },
                          [_vm._v("Ações")]
                        ),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.draftIntents, function (item) {
                        return _c("tr", { key: item.discipline_id }, [
                          _c("td", [_vm._v(_vm._s(item.name || "—"))]),
                          _c("td", { staticClass: "caption grey--text" }, [
                            _vm._v(_vm._s(item.code)),
                          ]),
                          _c("td", { staticClass: "text-right caption" }, [
                            _vm._v(_vm._s(_vm.formatWorkLoad(item))),
                          ]),
                          _c(
                            "td",
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    "x-small": "",
                                    color:
                                      item.origin === "module"
                                        ? "blue lighten-4"
                                        : "purple lighten-4",
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { "x-small": "", left: "" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.origin === "module"
                                            ? "mdi-layers-triple"
                                            : "mdi-cursor-default-click"
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.origin === "module"
                                          ? "Módulo"
                                          : "Manual"
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            { staticClass: "text-right" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    "x-small": "",
                                    title: "Remover do rascunho",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeDraftIntent(
                                        item.discipline_id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: "",
                                        color: "red darken-1",
                                      },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ],
                1
              )
            : _vm.groups.length === 0
            ? _c(
                "div",
                { staticClass: "grey--text caption text-center py-3" },
                [
                  _vm._v(
                    " Nenhuma disciplina no planejamento. Use o formulário acima para adicionar disciplinas de um módulo, ou marque pelo "
                  ),
                  _c(
                    "router-link",
                    { attrs: { to: "/percurso-formativo", target: "_blank" } },
                    [_vm._v("Percurso Formativo")]
                  ),
                  _vm._v(". "),
                ],
                1
              )
            : _c(
                "div",
                _vm._l(_vm.groups, function (grp, idx) {
                  return _c(
                    "div",
                    { key: grp.work_time.id, class: idx > 0 ? "mt-4" : "" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center mb-2" },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                left: "",
                                small: "",
                                color: "grey darken-1",
                              },
                            },
                            [_vm._v("mdi-calendar")]
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.workTimeLabel(grp.work_time))),
                          ]),
                          _c(
                            "v-chip",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                "x-small": "",
                                color: "green lighten-5",
                              },
                            },
                            [_vm._v(" " + _vm._s(grp.count) + " planejada(s) ")]
                          ),
                          grp.pending_count != null &&
                          grp.pending_count < grp.count
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ml-1",
                                  attrs: {
                                    "x-small": "",
                                    color: "grey lighten-2",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(grp.count - grp.pending_count) +
                                      " já gerada(s) "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.hasBlocking(grp)
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-chip",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: {
                                                      "x-small": "",
                                                      color: "amber lighten-4",
                                                    },
                                                  },
                                                  "v-chip",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      "x-small": "",
                                                      left: "",
                                                    },
                                                  },
                                                  [_vm._v("mdi-alert")]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.countBlocking(grp)
                                                    ) +
                                                    " com pré-req. pendente "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Disciplinas com pré-requisito não atendido. Resolva antes de gerar grids."
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _c("v-spacer"),
                          (grp.pending_count == null
                            ? grp.count
                            : grp.pending_count) > 0
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    color: "orange darken-1",
                                    text: "",
                                    title:
                                      "Gerar oferta para as disciplinas ainda pendentes",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$emit(
                                        "bulk-generate",
                                        _vm.pendingGroupSubset(grp)
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", small: "" } },
                                    [_vm._v("mdi-flash")]
                                  ),
                                  _vm._v(" Gerar Oferta "),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("v-simple-table", { attrs: { dense: "" } }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { attrs: { width: "64" } }, [
                              _vm._v("Ofertar"),
                            ]),
                            _c("th", [_vm._v("Disciplina")]),
                            _c("th", { attrs: { width: "100" } }, [
                              _vm._v("Código"),
                            ]),
                            _c(
                              "th",
                              {
                                staticClass: "text-right",
                                attrs: { width: "80" },
                              },
                              [_vm._v("CH")]
                            ),
                            _c("th", { attrs: { width: "120" } }, [
                              _vm._v("Origem"),
                            ]),
                            _c("th", { attrs: { width: "140" } }, [
                              _vm._v("Status"),
                            ]),
                            _c(
                              "th",
                              {
                                staticClass: "text-right",
                                attrs: { width: "60" },
                              },
                              [_vm._v("Ações")]
                            ),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(grp.intents, function (intent) {
                            return _c(
                              "tr",
                              {
                                key: intent.id,
                                class: [
                                  intent.has_grid ? "grid-generated-row" : "",
                                  intent.disabled ? "disabled-row" : "",
                                ],
                              },
                              [
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticStyle: {
                                                            display:
                                                              "inline-block",
                                                          },
                                                        },
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c("v-switch", {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: {
                                                          "input-value":
                                                            !intent.disabled,
                                                          disabled:
                                                            intent.has_grid ||
                                                            _vm.togglingId ===
                                                              intent.id,
                                                          loading:
                                                            _vm.togglingId ===
                                                            intent.id,
                                                          color: "success",
                                                          inset: "",
                                                          dense: "",
                                                          "hide-details": "",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleEnabled(
                                                              intent,
                                                              $event,
                                                              grp.work_time.id
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        intent.has_grid
                                          ? _c("span", [
                                              _vm._v(
                                                "Grid já gerado — não pode ser desligado por aqui"
                                              ),
                                            ])
                                          : intent.disabled
                                          ? _c("span", [
                                              _vm._v(
                                                "Desligada manualmente. Religar inclui no planejamento."
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "Ligada — será ofertada. Desligar marca como decisão manual de não ofertar."
                                              ),
                                            ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          intent.discipline
                                            ? intent.discipline.name
                                            : "—"
                                        ) +
                                        " "
                                    ),
                                    intent.has_join
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "ml-1",
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.openJoinDialog(
                                                                      intent
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-vector-link"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v("Ver detalhes da junção"),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  { staticClass: "caption grey--text" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        intent.discipline
                                          ? intent.discipline.code
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  { staticClass: "text-right caption" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatWorkLoad(intent.discipline)
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-chip",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            color:
                                                              intent.origin ===
                                                              "module"
                                                                ? "blue lighten-4"
                                                                : "purple lighten-4",
                                                          },
                                                        },
                                                        "v-chip",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            left: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              intent.origin ===
                                                                "module"
                                                                ? "mdi-layers-triple"
                                                                : "mdi-cursor-default-click"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            intent.origin ===
                                                              "module"
                                                              ? "Módulo"
                                                              : "Manual"
                                                          ) +
                                                          " "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        intent.origin === "module"
                                          ? _c("span", [
                                              _vm._v(
                                                "Adicionada em lote via seleção de módulo no cadastro de turma."
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "Marcada individualmente pelo Percurso Formativo."
                                              ),
                                            ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  [
                                    intent.disabled
                                      ? _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              color: "grey lighten-2",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  left: "",
                                                },
                                              },
                                              [_vm._v("mdi-power-plug-off")]
                                            ),
                                            _vm._v(" Não ofertada "),
                                          ],
                                          1
                                        )
                                      : intent.has_grid
                                      ? _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              color: "green lighten-4",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  left: "",
                                                },
                                              },
                                              [_vm._v("mdi-check-circle")]
                                            ),
                                            _vm._v(" Disciplinas das turmas "),
                                          ],
                                          1
                                        )
                                      : intent.prerequisite_ok
                                      ? _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              color: "green lighten-4",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  left: "",
                                                },
                                              },
                                              [_vm._v("mdi-check")]
                                            ),
                                            _vm._v(" Pré-req OK "),
                                          ],
                                          1
                                        )
                                      : !intent.has_grid &&
                                        !intent.prerequisite_ok
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-chip",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                                color:
                                                                  "amber lighten-4",
                                                              },
                                                            },
                                                            "v-chip",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                                left: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-alert"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " Aguardando pré-req "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("div", [
                                              _c("strong", [
                                                _vm._v(
                                                  "Pré-requisito(s) sem oferta anterior:"
                                                ),
                                              ]),
                                              _c(
                                                "ul",
                                                { staticClass: "ma-0 pl-3" },
                                                _vm._l(
                                                  intent.missing_prerequisites,
                                                  function (p) {
                                                    return _c(
                                                      "li",
                                                      { key: p.id },
                                                      [_vm._v(_vm._s(p.name))]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  { staticClass: "text-right" },
                                  [
                                    intent.has_grid
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                                loading:
                                                                  _vm.clearingIntentId ===
                                                                  intent.id,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.confirmClearOffer(
                                                                      intent,
                                                                      grp
                                                                        .work_time
                                                                        .id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color:
                                                                  "orange darken-1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-eraser"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "Limpar oferta (excluir disciplinas das turmas)"
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.clearDialog,
            callback: function ($$v) {
              _vm.clearDialog = $$v
            },
            expression: "clearDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-subtitle-1" }, [
                _vm._v("Limpar oferta da disciplina?"),
              ]),
              _c(
                "v-card-text",
                [
                  _c("p", [
                    _vm._v(" Esta ação "),
                    _c("strong", [_vm._v("exclui as disciplinas das turmas")]),
                    _vm._v(" de "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.clearTarget && _vm.clearTarget.discipline
                            ? _vm.clearTarget.discipline.name
                            : ""
                        )
                      ),
                    ]),
                    _vm._v(" no período letivo selecionado. "),
                  ]),
                  _vm.clearTarget && _vm.clearTarget.has_join
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mb-2 caption",
                          attrs: { type: "info", text: "", dense: "" },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-vector-link"),
                          ]),
                          _vm._v(
                            " Esta disciplina possui junção. As disciplinas das turmas serão "
                          ),
                          _c("strong", [_vm._v("desvinculadas da junção")]),
                          _vm._v(
                            " (a junção em si e as outras disciplinas vinculadas permanecem). "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("p", { staticClass: "caption grey--text mb-0" }, [
                    _vm._v(
                      " Disciplinas das turmas com professor atribuído não serão excluídos (você precisará remover a atribuição antes). "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.clearDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red darken-1",
                        text: "",
                        loading: _vm.clearing,
                      },
                      on: { click: _vm.doClearOffer },
                    },
                    [_vm._v("Limpar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("sys-find-discipline", {
        attrs: {
          showSelect: "",
          singleSelect: false,
          show: _vm.findDisciplineDialog,
        },
        on: {
          "update:show": function ($event) {
            _vm.findDisciplineDialog = $event
          },
          onSelect: _vm.onDisciplinesPicked,
        },
      }),
      _vm.groupId
        ? _c("join-info-dialog", {
            attrs: {
              show: _vm.joinDialog,
              "group-id": _vm.groupId,
              discipline: _vm.joinDialogDiscipline,
            },
            on: {
              "update:show": function ($event) {
                _vm.joinDialog = $event
              },
            },
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "640", scrollable: "" },
          model: {
            value: _vm.matrizPickerDialog,
            callback: function ($$v) {
              _vm.matrizPickerDialog = $$v
            },
            expression: "matrizPickerDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "text-subtitle-1" },
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-layers-outline"),
                  ]),
                  _vm._v(" Adicionar disciplinas da matriz "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.matrizPickerDialog = false
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("mdi-close"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pa-0", staticStyle: { "max-height": "60vh" } },
                [
                  !_vm.matrizDisciplines.length
                    ? _c(
                        "div",
                        { staticClass: "grey--text caption text-center py-6" },
                        [_vm._v(" Nenhuma disciplina na matriz. ")]
                      )
                    : _c(
                        "v-list",
                        { attrs: { dense: "", subheader: "" } },
                        [
                          _vm._l(_vm.modulesForPicker, function (mod) {
                            return [
                              _c(
                                "v-subheader",
                                {
                                  key: `h-${mod.id}`,
                                  staticClass: "grey lighten-4",
                                },
                                [_vm._v(_vm._s(mod.name))]
                              ),
                              _vm._l(
                                mod.sequencyDisciplines || [],
                                function (sd) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: `${mod.id}-${
                                        sd.discipline && sd.discipline.id
                                      }`,
                                      attrs: {
                                        disabled:
                                          !sd.discipline ||
                                          _vm.isMatrizItemDisabled(
                                            sd.discipline
                                          ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMatrizPick(
                                            sd.discipline
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-action",
                                        { staticClass: "mr-2" },
                                        [
                                          _c("v-simple-checkbox", {
                                            attrs: {
                                              value:
                                                _vm.isMatrizItemSelectedOrLocked(
                                                  sd.discipline
                                                ),
                                              disabled:
                                                !sd.discipline ||
                                                _vm.isMatrizItemDisabled(
                                                  sd.discipline
                                                ),
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.toggleMatrizPick(
                                                  sd.discipline
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  sd.discipline
                                                    ? sd.discipline.name
                                                    : "—"
                                                ) +
                                                " "
                                            ),
                                          ]),
                                          sd.discipline && sd.discipline.code
                                            ? _c(
                                                "v-list-item-subtitle",
                                                { staticClass: "caption" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        sd.discipline.code
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      sd.discipline &&
                                      _vm.isMatrizItemManualCursada(
                                        sd.discipline.id
                                      )
                                        ? _c(
                                            "v-list-item-action",
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { bottom: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({
                                                          on,
                                                          attrs,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-chip",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "amber lighten-4",
                                                                    },
                                                                  },
                                                                  "v-chip",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              ),
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                      left: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-check-bold"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.manualCompletionLabel(
                                                                        sd
                                                                          .discipline
                                                                          .id
                                                                      ) ||
                                                                        "Já cursada"
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("div", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        "Marcada manualmente como cursada"
                                                      ),
                                                    ]),
                                                    _vm.manualCompletions[
                                                      sd.discipline.id
                                                    ] &&
                                                    _vm.manualCompletions[
                                                      sd.discipline.id
                                                    ].notes
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass: "mt-1",
                                                          },
                                                          [
                                                            _c("em", [
                                                              _vm._v(
                                                                '"' +
                                                                  _vm._s(
                                                                    _vm
                                                                      .manualCompletions[
                                                                      sd
                                                                        .discipline
                                                                        .id
                                                                    ].notes
                                                                  ) +
                                                                  '"'
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : sd.discipline &&
                                          _vm.isMatrizItemAlreadyOffered(
                                            sd.discipline.id
                                          )
                                        ? _c(
                                            "v-list-item-action",
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { bottom: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({
                                                          on,
                                                          attrs,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-chip",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "green lighten-4",
                                                                    },
                                                                  },
                                                                  "v-chip",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              ),
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                      left: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-check-circle"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.workTimeLabelsFor(
                                                                        sd
                                                                          .discipline
                                                                          .id
                                                                      ) ||
                                                                        "Já ofertada"
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("div", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        "Ofertada nos períodos:"
                                                      ),
                                                    ]),
                                                    (
                                                      _vm.trailOfferedWorkTimes[
                                                        sd.discipline.id
                                                      ] || []
                                                    ).length
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "ma-0 pl-3",
                                                          },
                                                          _vm._l(
                                                            _vm
                                                              .trailOfferedWorkTimes[
                                                              sd.discipline.id
                                                            ],
                                                            function (wt) {
                                                              return _c(
                                                                "li",
                                                                { key: wt.id },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        wt.name ||
                                                                          wt.year +
                                                                            "/" +
                                                                            wt.period
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "caption",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Sem detalhes disponíveis."
                                                            ),
                                                          ]
                                                        ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : sd.discipline &&
                                          _vm.isAlreadyInPlanning(
                                            sd.discipline.id
                                          )
                                        ? _c(
                                            "v-list-item-action",
                                            [
                                              _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "green lighten-5",
                                                  },
                                                },
                                                [_vm._v("Já no planejamento")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("span", { staticClass: "caption grey--text ml-2" }, [
                    _vm._v(_vm._s(_vm.matrizPicked.length) + " selecionada(s)"),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.matrizPickerDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "purple darken-1",
                        depressed: "",
                        disabled: !_vm.matrizPicked.length,
                        loading: _vm.adding,
                      },
                      on: { click: _vm.confirmMatrizPick },
                    },
                    [_vm._v(" Adicionar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }